import { createWithEqualityFn } from "zustand/traditional";
import { createJSONStorage, persist } from "zustand/middleware";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { isWeb } from "@companion-core/shared/app/Utils/platform";

interface NewsletterState {
  dismissDate: number;
  isOpen: boolean;
}

interface NewsletterActions {
  setDismissDate: (dismissDate: number) => void;
  setIsOpen: (isOpen: boolean) => void;
}

export const initialState: NewsletterState = {
  dismissDate: -1,
  isOpen: false,
};

export const useNewsletterStore = createWithEqualityFn<NewsletterState & NewsletterActions>()(
  persist(
    (set) => ({
      ...initialState,
      setDismissDate: (dismissDate: number) => set({ dismissDate }),
      setIsOpen: (isOpen: boolean) => set({ isOpen }),
    }),
    {
      name: "newsletter-storage",
      storage: createJSONStorage(() => (isWeb() ? localStorage : AsyncStorage)),
      partialize: (state) => ({
        dismissDate: state.dismissDate,
      }),
    },
  ),
);
